// Core
import React, { useEffect, useState } from "react";
//Import Scss
import "./styles.scss";
import ImageModal from "../../../ImageModal"
//Import assets
import assets from "../../../../Assets";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchSingleFailureAnalysisRequest } from "../../../../Redux/Slices/failureAnalysisReqSlice";

const FailureDetails = (farId) => {
  const [failureDetailsData, setFailureDetailsData] = useState({});
  const { id } = useParams();
  const dispatch = useDispatch();
  
  useEffect(() => {
    getIndividualData();
  }, []);

  const getIndividualData = () => {
    dispatch(
      fetchSingleFailureAnalysisRequest({
        data: {
          remote_failure_details_id: id || farId.farId,
        },
        callBack: getFailureData,
      })
    );
  };

  const getFailureData = (data) => {
    setFailureDetailsData(data?.result);
  };

  return (
    <div className="FailureDetailsContainer">
      <div className="FailureDetailsHeader">
        <h2>Bearing Failure Details</h2>
      </div>
      <div className="FailureDetailsBody">
        <div className="FailureComponentsImagesContainer">
          <p>Failed Components:</p>
          <div className="FailureComponentsImages">
            {failureDetailsData?.file 
            ? 
            (<ImageModal src={failureDetailsData.file} alt="FailureComponentsImages" isDeleteReq = {false} />) 
            : 
            "-"}
            {/* <img src={failureDetailsData.file} alt="FailureComponentsImages" /> */}
          </div>
        </div>
        <div className="FailureDetailRow">
          <div className="FailureDetailRowLabel">Application</div>
          <div className="">:&nbsp;{failureDetailsData.application_or_position}</div>
        </div>
        <div className="FailureDetailRow">
          <div className="FailureDetailRowLabel">Failure Incident</div>
          <div className="">:&nbsp;{failureDetailsData.failure_details}</div>
        </div>
        <div className="FailureDetailRow">
          <div className="FailureDetailRowLabel">
            Consequences of the failure
          </div>
          <div>:&nbsp;{failureDetailsData.consequences_of_failure}</div>
        </div>
        <div className="FailureDetailRow">
          <div className="FailureDetailRowLabel">
            Additional Details
          </div>
          <div>:&nbsp;{failureDetailsData.additional_details}</div>
        </div>
      </div>
    </div>
  );
};

export default FailureDetails;
